import { defineComponent as _defineComponent } from 'vue'
import currentUser from 'bits/current_user'
import BaseButton from '@@/vuecomponents/base-button.vue'
import { storeToRefs } from 'pinia'
import { useDarkModeStore } from 'pinia/dark_mode'
import { useWindowSizeStore } from 'pinia/window_size'
import PadletLogo from 'vuecomponents/PadletLogo.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'contact_nav',
  setup(__props) {

// TODO: Render user profile if logged in
const darkModeStore = useDarkModeStore()
const { isDarkMode } = storeToRefs(darkModeStore)

const windowSizeStore = useWindowSizeStore()
const { isBiggerThanTabletLandscape } = storeToRefs(windowSizeStore)

const isLoggedIn = currentUser.email !== null

return { __sfc: true,darkModeStore, isDarkMode, windowSizeStore, isBiggerThanTabletLandscape, isLoggedIn, BaseButton, PadletLogo }
}

})